//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PrivacyHeader from '@/components/common/PrivacyHeader'
import { mapGetters } from 'vuex'
import scroll from '@/mixins/scroll'

export default {
  name: 'PrivacyPage',
  components: {
    PrivacyHeader,
  },
  mixins: [scroll],
  props: {
    pageId: {
      type: String,
      required: true,
      default: 'privacy_agreement',
    },
  },
  data() {
    return {
      isArchiveActive: false,
      pageData: {
        privacy_agreement: this.getDefaultData('privacyAgreementIsHidden'),
        privacy_kids: this.getData(
          'privacyAgreementKidsIsHidden',
          'privacyAgreementKidsTitle',
          'privacy_kids',
          'privacyAgreementKidsPdfList'
        ),
        terms_of_use: this.getData(
          'privacyTermsOfUseIsHidden',
          'privacyTermsOfUseTitle',
          'terms_of_use',
          'privacyTermsOfUsePdfList'
        ),
        cookies: this.getData(
          'privacyCookiesIsHidden',
          'privacyCookiesTitle',
          'cookies',
          'privacyCookiesPdfList'
        ),
        mail_agreement: this.getData(
          'privacyMailAgreementIsHidden',
          'privacyMailAgreementTitle',
          'mail_agreement',
          'privacyMailAgreementPdfList'
        ),
        arbitrary_document: this.getData(
          'privacyArbitraryDocumentIsHidden',
          'privacyArbitraryDocumentTitle',
          'arbitrary_document',
          'privacyArbitraryDocumentPdfList'
        ),
      },
    }
  },
  computed: {
    ...mapGetters({
      currentLanguageCode: 'landings/currentLanguageCode',
    }),
  },
  methods: {
    getData(isHiddenKey, titleKey, textKey, offerListKey) {
      if (this.$getTextSetting(isHiddenKey)) {
        return this.getDefaultData(isHiddenKey)
      }

      return {
        title: this.$getTextSetting(titleKey),
        text: this.$getTextSetting(textKey),
        archive: this.$getBullets(offerListKey),
        visible: true,
      }
    },
    getDefaultData(isHiddenKey) {
      return {
        title: this.$getTextSetting('privacyAgreementTitle'),
        text: this.$getTextSetting('privacy_agreement'),
        archive: this.$getBullets('privacyAgreementPdfList'),
        visible: !this.$getTextSetting(isHiddenKey),
      }
    },
    getText() {
      return this.pageData[this.pageId]?.text
        ? this.pageData[this.pageId]?.text
        : this.pageData.privacy_agreement?.text
    },
    getTitle() {
      return this.pageData[this.pageId]?.title
        ? this.pageData[this.pageId]?.title
        : this.pageData.privacy_agreement.title
    },
    currentLanguage() {
      return this.currentLanguageCode.substring(0, 2)
    },
    currentVersion(attr) {
      return this.pageData[attr]?.archive !== undefined &&
        this.pageData[attr]?.archive[0] !== undefined
        ? this.pageData[attr]?.archive[0].version
        : false
    },
    changePageId(url) {
      this.isArchiveActive = false
      this.$nuxt.$emit('change-page', url)
    },
  },
}
